/**
 * 連続したsymbolの値が使用できないこと
 */
export default {
  validate(
    value: string | undefined | null,
    { symbol }: { symbol: string }
  ): boolean {
    if (!value) {
      return true;
    }

    /** 連続したsymbolの値が入力できないこと */
    return !value.includes(symbol + symbol);
  },
};
